{
  "title": "Agents",
  "description": "Manage AI agents for evaluation and assessment processes",
  "table": {
    "search": "Search agents...",
    "add": "Add Agent",
    "name": "Name",
    "slug": "Slug",
    "instruction": "Instruction",
    "created_at": "Created",
    "actions": "Actions",
    "no_agents": "No agents found",
    "no_results": "No results found matching your search"
  },
  "add": {
    "title": "Add Agent",
    "description": "Create a new AI agent with custom instructions",
    "name": "Name",
    "name_placeholder": "Enter agent name",
    "slug": "Slug",
    "slug_placeholder": "agent-slug",
    "instruction": "Instruction",
    "instruction_placeholder": "Enter detailed instructions for the agent...",
    "cancel": "Cancel",
    "create": "Create Agent",
    "creating": "Creating..."
  },
  "edit": {
    "title": "Edit Agent",
    "description": "Update agent information and instructions",
    "name": "Name",
    "name_placeholder": "Enter agent name",
    "slug": "Slug",
    "slug_placeholder": "agent-slug",
    "instruction": "Instruction",
    "instruction_placeholder": "Enter detailed instructions for the agent...",
    "cancel": "Cancel",
    "save": "Save Changes",
    "saving": "Saving..."
  },
  "view": {
    "title": "Agent Details",
    "description": "View agent information and instructions",
    "name": "Name",
    "slug": "Slug",
    "instruction": "Instruction",
    "created_at": "Created At",
    "updated_at": "Updated At",
    "close": "Close"
  },
  "delete": {
    "title": "Delete Agent",
    "description": "Are you sure you want to delete the agent \"{{name}}\"?",
    "warning": "This action cannot be undone.",
    "cancel": "Cancel",
    "delete": "Delete Agent",
    "deleting": "Deleting..."
  },
  "errors": {
    "createAgentFailed": "Failed to create agent",
    "deleteAgentFailed": "Failed to delete agent",
    "loadAgentsFailed": "Failed to load agents",
    "updateAgentFailed": "Failed to update agent"
  },
  "success": {
    "createAgentSuccess": "Agent created successfully",
    "updateAgentSuccess": "Agent updated successfully",
    "deleteAgentSuccess": "Agent deleted successfully"
  }
}
